export default {
  name: 'virtualhorseraces',
  maxRacerNumber: 8,
};
